import {InjectionToken} from '@angular/core';
import {BasketModel} from 'app/domain/warehouse/data/models/basket/basket.model';
import {Find} from 'app/shared/data/crud.interface';
import {Identifiable} from 'app/shared/model/basic.model';

/**
 * Repository für Baskets
 */
export interface BasketRepository extends Find<BasketModel> {

  /**
   * Identifiziert den ersten Basket, der eine Position enthält, auf die die übergebene Artikelnummer 'article_number' zutrifft
   * @param articleNumber - die Artikelnummer, anhand der der Basket identifiziert werden soll
   * @returns Ein Promise, das die Id des Baskets zurückgibt, oder undefined, wenn kein Basket gefunden wurde.
   */
  findByArticleNumber(articleNumber: string): Promise<Identifiable | undefined>;
}

// InjectionToken für das BasketRepository
export const BASKET_REPOSITORY =
  new InjectionToken<BasketRepository>('BASKET_REPOSITORY');
